module.exports = __webpack_public_path__ + "img/fengcai5.cfb5246a.png";